import { useQuery } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';
import { Departments } from '@/types';

export const getProphetPages: prophetTypes.GetProphetPages = (params) => {
  return axios.get(`/prophet/pages`, { params });
};

type QueryFnType = typeof getProphetPages;

type UseGetProphetPages = {
  platform: string;
  department: Departments;
  config?: QueryConfig<QueryFnType>;
};

export const useGetProphetPages = ({ config = {}, platform, department }: UseGetProphetPages) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['prophet-pages', department, platform],
    queryFn: () => getProphetPages({ department, platform }),
  });
};
